import { render, staticRenderFns } from "./BlMor.vue?vue&type=template&id=7e1c0548"
import script from "./BlMor.vue?vue&type=script&lang=js"
export * from "./BlMor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports